module.exports = __webpack_public_path__ + "img/010019.a9e3fb3c.png";